import React, { Component } from 'react';

export default class Methods extends Component {
  render() {
    return (
      <table className="options">
        <thead>
          <tr>
            <th>Method</th>
            <th>Usage</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>open()</td>
            <td>PopupboxManager.open({`{content, [config]}`})</td>
          </tr>
          <tr>
            <td>update()</td>
            <td>PopupboxManager.update({`{[content], [config]}`}}</td>
          </tr>
          <tr>
            <td>close()</td>
            <td>PopupboxManager.close()</td>
          </tr>
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./components/methods.js